import React, { useState, useEffect } from "react";
import { Menu } from "antd";
import { Link, NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/images/footer-logo.png";
import {
  LayoutDashboard,
  CircleDollarSign,
  FileText,
  Layout,
  User,
  Image as ImageIcon,
  Megaphone,
  PieChart,
  Settings,
  Wrench
} from "lucide-react";

function Sidenav({ color }) {
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");

  const getInitialOpenKeys = () => {
    if (page.includes("reward-point") || page.includes("redemptions-settings") || page.includes("reward-system-details")) return ["reward-points-sub"];
    if (page.startsWith("sales/") || ["sales", "orders", "clients"].includes(page)) return ["sales-sub"];
    if (page.startsWith("catalog/") || ["products", "categories", "attributes", "attribute-families"].includes(page)) return ["catalog-sub"];
    if (page.startsWith("customer") || ["customers", "groups", "reviews"].includes(page)) return ["customers-sub"];
    if (page.startsWith("reporting/")) return ["reporting-sub"];
    if (page.startsWith("settings/")) return ["settings-sub"];
    return [];
  };

  const [openKeys, setOpenKeys] = useState(getInitialOpenKeys());

  useEffect(() => {
    const currentKeys = getInitialOpenKeys();
    if (currentKeys.length > 0) {
      setOpenKeys(currentKeys);
    }
  }, [page]);

  const onOpenChange = (keys) => {
    const rootSubmenuKeys = ["sales-sub", "catalog-sub", "settings-sub", "reward-points-sub", "reporting-sub"];
    const latestOpenKey = keys.find((key) => !openKeys.includes(key));
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const getIconColor = (itemPage) => {
    return page === itemPage ? "#fff" : "#64748b";
  };

  const menuItems = [
    {
      key: "dashboard",
      label: (
        <NavLink to="/dashboard">
          <span
            className="icon"
            style={{
              background: page === "dashboard" ? color : "",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <LayoutDashboard size={18} color={getIconColor("dashboard")} />
          </span>
          <span className="label">Dashboard</span>
        </NavLink>
      ),
    },
    // {
    //   key: "reward-point",
    //   label: (
    //     <NavLink to="/reward-point" >
    //       <span
    //         className="icon"
    //         style={{
    //           background: page === "reward-point" ? color : "",
    //           display: "flex",
    //           alignItems: "center",
    //           justifyContent: "center",
    //         }}
    //       >
    //         <CircleDollarSign
    //           size={18}
    //           color={page === "reward-point" ? "#fff" : "#64748b"}
    //         />
    //       </span>

    //       <span className="label">Points On Product</span>
    //     </NavLink>
    //   ),
    // },
    {
      key: "sales-sub",
      label: (
        <>
          <span
            className="icon"
            style={{
              background: ["sales", "orders", "clients"].includes(page) ? color : "",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FileText size={18} color={["sales", "orders", "clients"].includes(page) ? "#fff" : "#64748b"} />
          </span>
          <span className="label">Sales</span>
        </>
      ),
      children: [
        {
          key: "orders",
          label: <NavLink to="/sales/orders">Orders</NavLink>,
        },
        {
          key: "shipments",
          label: <NavLink to="/sales/shipments">Shipments</NavLink>,
        },
        {
          key: "invoices",
          label: <NavLink to="/sales/invoices">Invoices</NavLink>,
        },
        // {
        //   key: "refunds",
        //   label: <NavLink to="/sales/refunds">Refunds</NavLink>,
        // },
        {
          key: "transactions",
          label: <NavLink to="/sales/transactions">Transactions</NavLink>,
        },
      ],
    },
    {
      key: "catalog-sub",
      label: (
        <>
          <span
            className="icon"
            style={{
              background: ["products", "categories", "attributes", "attribute-families"].includes(page)
                ? color
                : "",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Layout
              size={18}
              color={
                ["products", "categories", "attributes", "attribute-families"].includes(page)
                  ? "#fff"
                  : "#64748b"
              }
            />
          </span>
          <span className="label">Catalog</span>
        </>
      ),
      children: [
        {
          key: "products",
          label: <NavLink to="/catalog/products">Products</NavLink>,
        },
        {
          key: "categories",
          label: <NavLink to="/catalog/categories">Category</NavLink>,
        },
        {
          key: "attributes",
          label: <NavLink to="/catalog/attributes">Attribute</NavLink>,
        },
        // {
        //   key: "attribute-families",
        //   label: (
        //     <NavLink to="/catalog/attribute-families">
        //       Attribute Families
        //     </NavLink>
        //   ),
        // },
      ],
    },
    {
      key: "customers",
      label: (

        <NavLink to="/customers" >
          <span
            className="icon"
            style={{
              background: page === "customers" ? color : "",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <User
              size={18}
              color={page === "customers" ? "#fff" : "#64748b"}
            />
          </span>

          <span className="label">Customers</span>
        </NavLink>
      ),
    },
    {
      key: "settings-sub",
      label: (
        <>
          <span
            className="icon"
            style={{
              background: ["profile", "admin-email"].includes(page)
                ? color
                : "",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Settings
              size={18}
              color={
                ["profile", "admin-email"].includes(page)
                  ? "#fff"
                  : "#64748b"
              }
            />
          </span>

          <span className="label">Settings</span>
        </>
      ),

      children: [
        {
          key: "profile",
          label: <NavLink to="/profile">Profile</NavLink>,
        },
        {
          key: "admin-email",
          label: (
            <NavLink to="/settings/admin-email">
              Admin Email
            </NavLink>
          ),
        },
        // {
        //   key: "website-settings",
        //   label: (
        //     <NavLink to="/settings/website-settings">
        //       Website Settings
        //     </NavLink>
        //   ),
        // }
      ],
    },
    // {
    //   key: "cms",
    //   label: (
    //     <NavLink to="/cms">
    //       <span
    //         className="icon"
    //         style={{
    //           background: page === "cms" ? color : "",
    //           display: "flex",
    //           alignItems: "center",
    //           justifyContent: "center",
    //         }}
    //       >
    //         <ImageIcon size={18} color={getIconColor("cms")} />
    //       </span>
    //       <span className="label">CMS</span>
    //     </NavLink>
    //   ),
    // },
    // {
    //   key: "marketing",
    //   label: (
    //     <NavLink to="/marketing">
    //       <span
    //         className="icon"
    //         style={{
    //           background: page === "marketing" ? color : "",
    //           display: "flex",
    //           alignItems: "center",
    //           justifyContent: "center",
    //         }}
    //       >
    //         <Megaphone size={18} color={getIconColor("marketing")} />
    //       </span>
    //       <span className="label">Marketing</span>
    //     </NavLink>
    //   ),
    // },
    // {
    //   key: "reporting-sub",
    //   label: (
    //     <>
    //       <span
    //         className="icon"
    //         style={{
    //           background: ["reporting/sales", "reporting/customers", "reporting/products"].includes(page) ? color : "",
    //           display: "flex",
    //           alignItems: "center",
    //           justifyContent: "center",
    //         }}
    //       >
    //         <PieChart size={18} color={["reporting/sales", "reporting/customers", "reporting/products"].includes(page) ? "#fff" : "#64748b"} />
    //       </span>
    //       <span className="label">Reporting</span>
    //     </>
    //   ),
    //   children: [
    //     {
    //       key: "reporting-sales",
    //       label: <NavLink to="/reporting/sales">Sales</NavLink>,
    //     },
    //     {
    //       key: "reporting-customers",
    //       label: <NavLink to="/reporting/customers">Customers</NavLink>,
    //     },
    //     {
    //       key: "reporting-products",
    //       label: <NavLink to="/reporting/products">Products</NavLink>,
    //     },
    //   ],
    // },

    // {
    //   key: "configure",
    //   label: (
    //     <NavLink to="/configure">
    //       <span
    //         className="icon"
    //         style={{
    //           background: page === "configure" ? color : "",
    //           display: "flex",
    //           alignItems: "center",
    //           justifyContent: "center",
    //         }}
    //       >
    //         <Wrench size={18} color={getIconColor("configure")} />
    //       </span>
    //       <span className="label">Configure</span>
    //     </NavLink>
    //   ),
    // },
  ];
  return (
    <>
      <div className="brand">
        <Link to="/dashboard" className="main-logo">
          <img src={logo} alt="Logo" />
        </Link>
      </div>
      <Menu
        theme="light"
        mode="inline"
        items={menuItems}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
      />
    </>
  );
}

export default Sidenav;
